module.exports = "/images/img_login.png?c520604b59b18798dece343ecf4563ee";